import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { BadgeComponent } from './badge.component';

@NgModule({
  declarations: [BadgeComponent],
  imports: [CommonModule, BadgeModule],
  exports: [BadgeModule, BadgeComponent],
})
export class BadgeComponentModule {}
